<div class="xux-tabs-body p-0">
  <div class="date-period-calendar">
    <ul class="date-period-years">
      <li *ngFor="let year of years"
          [class.active]="year == value.year"
          (click)="selectYear(year)">
        {{year}}
      </li>
    </ul>

    <ul class="date-period-periods">
        <li class="date-period-period"
            *ngFor="let period of periods"
            [class.active]="value.period == period"
            (click)="selectPeriod(period)"
            [class.invisible]="!value.year">
          P{{period}}
        </li>
    </ul>

    <ul class="date-period-weeks">
        <li  *ngFor="let week of weeks" (click)="selectWeek(week, true)"
             [class.active]="compareWeek(value, week)"
             [class.current]="compareWeek(currentPeriod, week)"
             >
          {{prepareLabel(week)}} {{formatDate(week.dateStart, config.dateFormat.short_date_format)}} - {{formatDate(week.dateEnd, config.dateFormat.short_date_format)}}
        </li>
    </ul>
  </div>
</div>
